import React, { useState } from 'react';
import './Publications.css';
import { FaExternalLinkAlt, FaTimes, FaQuoteRight } from 'react-icons/fa';
import { publicationsData } from '../data/portfolioData';
import museumImage from '../images/Museum_of_Science_and_Industry_(Chicago).jpg';

const Publications: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const getImage = (pub: typeof publicationsData[0]) => {
    if (pub.image === 'museum') return museumImage;
    return pub.image || '';
  };

  return (
    <div className="publications-container">
      <h2 className="publications-title">Publications</h2>
      <div className="publications-grid">
        {publicationsData.map((pub, index) => (
          <div
            key={index}
            className={`publication-card ${expandedIndex === index ? 'active' : ''}`}
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
            onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
          >
            <div className="pub-thumbnail">
              <img src={getImage(pub)} alt={pub.title} className="pub-image" />
              <div className="pub-overlay">
                <h3 className="pub-title-overlay">{pub.title}</h3>
                {pub.citations !== undefined && (
                  <span className="pub-citations-badge">
                    <FaQuoteRight /> {pub.citations} citations
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {expandedIndex !== null && (
        <div className="pub-detail-backdrop" onClick={() => setExpandedIndex(null)}>
          <div className="pub-detail-panel" onClick={(e) => e.stopPropagation()}>
            <button className="pub-detail-close" onClick={() => setExpandedIndex(null)}>
              <FaTimes />
            </button>
            <div className="pub-detail-hero">
              <img
                src={getImage(publicationsData[expandedIndex])}
                alt={publicationsData[expandedIndex].title}
                className="pub-detail-hero-image"
              />
              <div className="pub-detail-hero-gradient" />
              <h2 className="pub-detail-hero-title">{publicationsData[expandedIndex].title}</h2>
            </div>
            <div className="pub-detail-body">
              <div className="pub-detail-meta">
                <span className="pub-detail-venue">{publicationsData[expandedIndex].venue} &middot; {publicationsData[expandedIndex].year}</span>
                {publicationsData[expandedIndex].citations !== undefined && (
                  <span className="pub-detail-citations">
                    <FaQuoteRight /> {publicationsData[expandedIndex].citations} citations
                  </span>
                )}
              </div>
              <p className="pub-detail-authors">{publicationsData[expandedIndex].authors}</p>
              <p className="pub-detail-abstract">{publicationsData[expandedIndex].abstract}</p>
              <a
                href={publicationsData[expandedIndex].link}
                target="_blank"
                rel="noopener noreferrer"
                className="pub-detail-link"
              >
                <FaExternalLinkAlt /> View Publication
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Publications;
